module.exports = "/images/retirement-background.png?8e5a2441b09ba2082a55aea9f8c2a417";